import { WatchDogPopupProps } from 'components/Blocks/Product/WatchDog/Popup/WatchDogPopup';
import { WatchProductPersooDetailType } from 'modules/persoo/persooTypes';
import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';
import { useSessionStore } from 'store/useSessionStore';

const WatchDogPopup = dynamic<WatchDogPopupProps>(() =>
    import('components/Blocks/Product/WatchDog/Popup/WatchDogPopup').then((component) => component.WatchDogPopup),
);

export const PersooWatchDog: FC = () => {
    const [productForWatchDog, setProductForWatchDog] = useState<WatchProductPersooDetailType | null>(null);
    const updatePortalContent = useSessionStore((s) => s.updatePortalContent);

    useEffect(() => {
        const handleAddToCartFromPersoo = (event: CustomEvent<WatchProductPersooDetailType>) => {
            const { itemId, itemName } = event.detail;
            setProductForWatchDog({ itemId, itemName });
        };

        document.addEventListener('persoo:watch-product', handleAddToCartFromPersoo);
    }, []);

    useEffect(() => {
        if (productForWatchDog) {
            updatePortalContent(
                <WatchDogPopup
                    productName={productForWatchDog.itemName}
                    productUuid={productForWatchDog.itemId}
                    onCloseCallback={() => setProductForWatchDog(null)}
                />,
            );
        }
    }, [productForWatchDog, updatePortalContent]);

    return null;
};
